import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchZoneDetail, searchBins, resetCurrentBin, selectBin, deleteBin } from '../../actions/zones_actions';

import ZoneDetail from '../../components/Inventories/zoneDetail';

let zoneDetail = reduxForm({
    form: 'zoneDetail'
})(ZoneDetail);

const selector = formValueSelector('zoneDetail')

function mapStateToProps(state) {
    const nameValue = selector(state, 'BinName');
    return {
        nameValue,

        bins: state.zones.bins,

        currentZone: state.zones.currentZone,
        currentZoneDetail: state.zones.currentZoneDetail,
        detailIsLoading: state.zones.detailIsLoading,
        detailError: state.zones.detailError,
        currentBin: state.zones.currentBin,
        deleteBin: state.zones.deleteBin,
        deleteBinSuccess: state.zones.deleteBinSuccess,
        deleteBinFailureError: state.zones.deleteBinFailureError,
    }
}

export default connect(mapStateToProps, { fetchZoneDetail, searchBins, resetCurrentBin, selectBin,deleteBin })(zoneDetail)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/zoneDetail.jsx